__turbopack_context__.v({
  "buttonGroup": "ButtonGroup-module__88yvnW__buttonGroup",
  "buttonGroupCenter": "ButtonGroup-module__88yvnW__buttonGroupCenter",
  "buttonGroupFullWidth": "ButtonGroup-module__88yvnW__buttonGroupFullWidth",
  "buttonGroupLeft": "ButtonGroup-module__88yvnW__buttonGroupLeft",
  "buttonGroupRight": "ButtonGroup-module__88yvnW__buttonGroupRight",
  "buttonGroupSpaceBetween": "ButtonGroup-module__88yvnW__buttonGroupSpaceBetween",
});
